"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const nanoevents_1 = __importDefault(require("nanoevents"));
const request_1 = require("../request");
/**
 * Abstract superclass.
 */
class Base {
    constructor(config, req = new request_1.AxiosRequest(config.axiosConfig)) {
        this.config = config;
        this.req = req;
        this.emitter = new nanoevents_1.default();
    }
    on(name, callBack) {
        return this.emitter.on(name, callBack);
    }
    emit(name, value) {
        return this.emitter.emit(name, value);
    }
}
exports.default = Base;
//# sourceMappingURL=base.js.map